module.exports = __webpack_public_path__ + "releases/5e388a936ef3f0d6aeb56f9f236dcef73a6acfd8/img/logo-fill-adeagro.dcabc627.svg";